<template>
  <div class="parteners">
    <div
      class="
        d-flex
        parteners__title
          justify-content-between
        align-items-center
        mb-4
      "
    >
    <div class="row col-md-12">
        <div class="col-md-4">
            <h3 class="mb-0">الشركاء</h3>
        </div>
        <div class="col-md-1">
        <div class="d-flex flex-row-reverse">
          <div style="padding: 15px; background: #fff">
            <h6 class="text-center"><b>إجمالي</b></h6>
            <h6 class="mb-0">
              {{ (totalAmount).toLocaleString('en-US')  }}
            </h6>
          </div>
        </div>
        </div>
      
        <div class="col-md-2 mt-2" >
           <el-button plain  type="primary" @click="openAddProjectProfit = true"
        >توزيع ارباح  المشاريع العقاريه</el-button
      >
        </div>
        <div class="col-md-2 mt-2">
           <el-button plain  type="primary" @click="openAddInvestmentProfit = true;"
        >توزيع ارباح  المشاريع الاستثمارات</el-button
      >
        </div>
          <div class="col-md-2 mt-2" >
           <el-button plain  type="primary" @click="openAddPartener = true"
        >إضافة شريك</el-button
      >
        </div>

    </div>
      <!-- <h3 class="mb-0">الشركاء</h3>
      <el-button plain type="primary" @click="openAddPartener = true"
        >إضافة</el-button
      > -->
    </div>

    <div class="parteners__list">
      <div
        v-for="partener in parteners"
        class="parteners__card text-center"
        :key="partener.id"
      >
        <b >{{ partener.name }}</b>
        <h6 class="mt-2">{{ partener.phone }}</h6>
        <h6 class="mt-2" v-if="partener.address">{{ partener.address }}</h6>
        <h6 v-else class="text-danger">لا يوجد عنوان</h6>
        <h6 class="mt-2">{{ (partener.account + partener.balance).toLocaleString('en-US') }} </h6>
        <!-- <h6 class="mt-2 text-danger">{{numberToFixed(((partener.account + partener.balance) / totalAmount)* 100)}} %</h6> -->
        <!-- <h6 class="type-1" v-if="partener.type == 1">إيداع</h6>
        <h6 class="type-0" v-else-if="partener.type == 0">سحب</h6> -->

        <div class=" mt-2">
           <el-row type="flex" :gutter="10">
            
             <el-col :lg="8" :span="12">
              
            
             </el-col>
         
              <el-col :lg="8" :span="12">
        <h6 class="mt-2 text-danger">{{partener.profitPercentage>0?partener.profitPercentage:0}} %</h6>
        <!-- <h6 class="mt-2 text-danger">{{numberToFixed(((partener.account + partener.balance) / totalAmount)* 100)}} %</h6> -->

             </el-col>
           </el-row>
        
      
        </div>

         <div class="locations__actions">
                  
                  <div class="actions mb-0 mt-2">
                      <el-button
                        style="padding: 7px 15px"
                        plain
                        type="success"
                        @click="
                          $router.push(
                            `/parteners/${partener.id}?name=${partener.name}&account=${partener.account}&balance=${partener.balance}`
                          )
                        "
                      >
                        التفاصيل</el-button
                      >
                      
                      <button  @click.stop="editPartner(partener)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Icon"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <rect
                            id="Area"
                            width="20"
                            height="20"
                            fill="#fcfcfc"
                            opacity="0"
                          />
                          <g
                            id="Icon-2"
                            data-name="Icon"
                            transform="translate(1.566 1.566)"
                          >
                            <path
                              id="Path"
                              d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                              transform="translate(0.101 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                              transform="translate(-6.667 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                          </g>
                        </svg>
                      </button>
                     

                      <el-popconfirm
                       v-if="(partener.account + partener.balance)==0"
                        :cancel-button-text="'إلغاء'"
                        :confirm-button-text="'حذف'"
                           :title="'هل تريد حذف ' + ' ' + partener.name + ' ؟'"
                    @confirm="destroy(partener)"
                      >
                        <button slot="reference" @click.stop>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Icon"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              id="Area"
                              width="20"
                              height="20"
                              fill="#fcfcfc"
                              opacity="0"
                            />
                            <g
                              id="Icon-2"
                              data-name="Icon"
                              transform="translate(2.5 1.667)"
                            >
                              <path
                                id="Path"
                                d="M17.5,5H2.5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <path
                                id="Path-2"
                                data-name="Path"
                                d="M4.167,5V16.667a1.666,1.666,0,0,0,1.666,1.666h8.334a1.666,1.666,0,0,0,1.666-1.666V5m-2.5,0V3.333a1.666,1.666,0,0,0-1.666-1.666H8.333A1.666,1.666,0,0,0,6.667,3.333V5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line"
                                y2="5"
                                transform="translate(9.167 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line-2"
                                data-name="Line"
                                y2="5"
                                transform="translate(5.833 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                            </g>
                          </svg>
                        </button>
                      </el-popconfirm>
                    </div>

                      <span style="margin-right:50%">  </span>
                  </div>
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة شريك"
      :active.sync="openAddPartener"
    >
      <div class="popup-calender">
        <el-form :model="addPartener" ref="addPartener">
          <h6>اسم الشريك</h6>
          <el-form-item
            style="min-width: 300px"
            prop="name"
            :rules="[{ required: true, message: 'الاسم مطلوب' }]"
          >
            <el-input v-model="addPartener.name"></el-input>
          </el-form-item>

          <h6>رقم الهاتف</h6>
          <el-form-item
            style="min-width: 300px"
            prop="phone"
            :rules="[{ required: true, message: 'رقم الهاتف مطلوب' }]"
          >
            <el-input v-model="addPartener.phone"></el-input>
          </el-form-item>

          <h6>الرصيد
            <span class="mr-5" v-if="addPartener.account">( {{convertNumber(addPartener.account)}} )</span>
          </h6>
          <el-form-item
            style="min-width: 300px"
            prop="account"
            :rules="[{ required: true, message: 'الرصيد مطلوب' }]"
          >
            <el-input type="number" v-model="addPartener.account"></el-input>
          </el-form-item>

          <h6>العنوان</h6>
          <el-form-item
            style="min-width: 300px"
            prop="address"
          >
            <el-input v-model="addPartener.address"></el-input>
          </el-form-item>


          <el-form-item>
            <div>
              <el-button type="primary" @click="onAddPartener('addPartener')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
    <vs-popup
      class="popup-width-300"
      title="تعديل بيانات الشريك"
      :active.sync="openEditModal"
    >
      <div class="popup-calender">
        <el-form :model="currentPartner" ref="updatePartner">
          <h6>اسم الشريك</h6>
          <el-form-item
            style="min-width: 300px"
            prop="name"
            :rules="[{ required: true, message: 'الاسم مطلوب' }]"
          >
            <el-input v-model="currentPartner.name"></el-input>
          </el-form-item>

          <h6>رقم الهاتف</h6>
          <el-form-item
            style="min-width: 300px"
            prop="phone"
            :rules="[{ required: true, message: 'رقم الهاتف مطلوب' }]"
          >
            <el-input v-model="currentPartner.phone"></el-input>
          </el-form-item>

          

          <h6>العنوان</h6>
          <el-form-item
            style="min-width: 300px"
            prop="address"
          >
            <el-input v-model="currentPartner.address"></el-input>
          </el-form-item>


          <el-form-item>
            <div>
              <el-button type="primary" @click="onUpdate('updatePartner')">
                تعديل البيانات
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <!-- investment project profit -->
          <vs-popup
      class="popup-width-300"
      title="توزيع ارباح المشروعات الاستثماريه  "
      :active.sync="openAddInvestmentProfit"
    >
      <div class="popup-calender">
        <el-form :model="addInvestmentProfit" ref="addInvestmentProfit">

           <h6>حدد المشروع </h6>
          <el-form-item
            prop="project_id"
            :rules="[{ required: true, message: ' تحديد المشروع مطلوب' }]"
          >
            <el-select
              searchable
              @focus="index = 0"
              class="mt-2 col-12 p-0"
              v-model="addInvestmentProfit.project_id"
              placeholder=". "
            >
              <el-option
                v-for="item in investments"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <h6 class="mb-1">
            الارباح
            <span class="mr-5" v-if="addInvestmentProfit.amount"
              >( {{ convertNumber(addInvestmentProfit.amount) }} )</span
            >
          </h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'قيمة الارباح مطلوبة' }]"
          >
            <el-input type="number" v-model="addInvestmentProfit.amount"></el-input>
          </el-form-item>

        

         

          <el-form-item>
            <div>
              <el-button type="primary" @click="storeInvestmentProfit()">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
    <!-- end investment -->
    <!--  project profit -->
          <vs-popup
      class="popup-width-300"
      title="توزيع ارباح المشروعات العقاريه  "
      :active.sync="openAddProjectProfit"
    >
      <div class="popup-calender">
        <el-form :model="addProjectProfit" ref="addProjectProfit">

           <h6>حدد المشروع </h6>
          <el-form-item
            prop="project_id"
            :rules="[{ required: true, message: ' تحديد المشروع مطلوب' }]"
          >
            <el-select
              searchable
              @focus="index = 0"
              class="mt-2 col-12 p-0"
              v-model="addProjectProfit.project_id"
              placeholder=". "
            >
              <el-option
                v-for="item in projects"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <h6 class="mb-1">
            الارباح
            <span class="mr-5" v-if="addProjectProfit.amount"
              >( {{ convertNumber(addProjectProfit.amount) }} )</span
            >
          </h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'قيمة الارباح مطلوبة' }]"
          >
            <el-input type="number" v-model="addProjectProfit.amount"></el-input>
          </el-form-item>

        

         

          <el-form-item>
            <div>
              <el-button type="primary" @click="storeProjectProfit()">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
    <!-- end investment -->
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
export default {
  mounted() {
    this.getParteners();
    this.getProjects();
    this.getInvestments();
  },
  data() {
    return {
      totalAmount:0,
      openEditModal:false,
      openAddInvestmentProfit:false,
      addInvestmentProfit: {},
      openAddProjectProfit:false,
      addProjectProfit: {},
      addPartener: {},
      currentPartner: {},
      investments: [],
      projects: [],
      parteners: [],
      partenerType: [
        { text: "سحب", val: 0 },
        { text: "إيداع", val: 1 },
      ],
      openAddPartener: false,
    };
  },
  methods: {
    onUpdate(formName){
      // alert(formName)
       this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitUpdatePartner();
        }
      });
    },
      editPartner(partner) {
      this.openEditModal = true;
      this.currentPartner = partner;
    },
     submitUpdatePartner() {

      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .put(`/parteners/${this.currentPartner.id}`, this.currentPartner)
        .then(() => {
          this.currentPartner = {};
          this.openEditModal = false;
          this.getParteners();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الشريك بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .finally(() => loading.close());
    },
    storeInvestmentProfit(){
      this.$refs.addInvestmentProfit.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/investment-profit`, {
              ...this.addInvestmentProfit,
              partners: this.parteners,
              amount: +this.addInvestmentProfit.amount,
              type:1
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.getParteners();
              this.addInvestmentProfit = {};
              this.openAddInvestmentProfit = false;
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify({
                  title: "عفوا المبلغ المطلوب غير متوفر ",
                  message: `المتوفر الان ${err.response.data.balance}`,
                  type: "error",
                  duration: 1500,
                });
              } else {
                this.$notify({
                  title: "حدث خطأ",
                  message: "عفوا لم تتم العملية ",
                  type: "error",
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    storeProjectProfit(){
      this.$refs.addProjectProfit.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/investment-profit`, {
              ...this.addProjectProfit,
              partners: this.parteners,
              amount: +this.addProjectProfit.amount,
              type:2
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.getParteners();
              this.addProjectProfit = {};
              this.openAddProjectProfit = false;
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify({
                  title: "عفوا المبلغ المطلوب غير متوفر ",
                  message: `المتوفر الان ${err.response.data.balance}`,
                  type: "error",
                  duration: 1500,
                });
              } else {
                this.$notify({
                  title: "حدث خطأ",
                  message: "عفوا لم تتم العملية ",
                  type: "error",
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
     numberToFixed(number) {
      return Number(number).toFixed(2);
    },
         convertNumber(val){
      if(val>0){
      return Number(val).toLocaleString('en-US');
      }else{
        return "";
      }

    },
    onAddPartener(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveAddPartener();
        }
      });
    },
    saveAddPartener() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post("/parteners", this.addPartener)
        .then(() => {
          this.addPartener = {};
          this.openAddPartener = false;
          this.getParteners();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الشريك بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .finally(() => loading.close());
    },
      destroy(partener) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
                axiosApi
                  .delete("parteners/" + partener.id)
                  .then(res => {
                   this.parteners = res.data;
                    this.$snotify.success("تم حذف الشريك بنجاح");
                  })
                  .catch(e => {
                    
                    console.log(e);
                  }) .finally(() => loading.close());
            
        
      
    },
    getParteners() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get("/parteners")
        .then((res) => {
          this.parteners = res.data;
          this.totalAmount=0;
          this.parteners.map((partener)=>{
            this.totalAmount+= +partener.account + +partener.balance
          })
           this.parteners.map((partener)=>{
            partener['profitPercentage']=  +this.numberToFixed((partener.account + partener.balance) / this.totalAmount* 100)
          })
          
          // console.log("this.parteners",this.parteners)
        })
        .finally(() => loading.close());
    },
    getProjects() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get("/projects")
        .then((res) => {
          this.projects = res.data;
        })
        .finally(() => loading.close());
    },
    getInvestments() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get("/investments")
        .then((res) => {
          this.investments = res.data;
         
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">


.parteners {
  padding: 25px;
  &__list {
    display: grid;
    gap: 25px;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  &__card {
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 2px 1px 10px 3px #dddddd52;
    h5 {
      text-align: center !important;
      font-size: 24px;
    }
    h6 {
      text-align: center !important;
    }
    .type-1 {
      color: var(--bs-success);
      font-weight: bold;
    }
    .type-0 {
      font-weight: bold;

      color: var(--bs-danger);
    }
  }
}
</style>
